@let cabangaLite = cabangaLite$ | async;

<h1 class="flex flex-wrap content-center text-center margin-bottom-50px gap-10px">À propos <span>{{cabangaLite ? 'Horizon - Présences' : 'Cabanga'}}</span></h1>

<div class="flex flex-row content-start flex-column-lt-md gap-10px">
  <div  class="flex flex-1 content-start items-center flex-column text-center">
    <p><mat-icon>business</mat-icon></p>
    <p>
      {{cabangaLite ? 'Horizon - Présences' : 'Cabanga'}} est un produit développé et commercialisé par <a href="https://scolares.be/" target="_blank">Scolares ASBL</a> | TVA : BE446.262.356
    </p>
  </div>
  <mat-divider style="height:200px" class="hidden-lt-md" vertical></mat-divider>
  <div class="flex flex-1 content-start items-center flex-column text-center">
    <p><mat-icon>article</mat-icon></p>
    <p>
      Conditions générales d'utilisation
      <a href="https://www.cabanga.be/official_docs/CGU.pdf" target="_blank">ici</a>
    </p>
  </div>
  <mat-divider style="height:200px" class="hidden-lt-md" vertical></mat-divider>
  <div class="flex flex-1 content-start items-center flex-column text-center">
    <p><mat-icon>privacy_tip</mat-icon></p>
    <p>
      Politique de protection des données à caractère personnel
      <a href="https://www.cabanga.be/official_docs/PPDCP.pdf" target="_blank">ici</a>
    </p>
  </div>
</div>

<p class="app-information">
  Version: {{version}}
  <button mat-button color="primary" (click)="refreshApp()">
    <mat-icon>update</mat-icon>
    Recharger l'application
  </button>
</p>
